import { css } from "lit";

export const iconButtonStyles = css`

`;